import Domain from "./domain";
export default {
  methods: {
    authCompany: async function(companyId) {
      try {
        // "company/token?_id="
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "company/token?_id=" + companyId,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getCompanies: async function() {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "company/details",
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getCompanyPolicies: async function(companyId, url, port) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN +
            "policy/company/details/" +
            companyId +
            "?domain=" +
            url +
            "&port=" +
            port,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getCompanyById: async function(id) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "company/details?status=&_id=" + id,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    postCompany: async function(obj) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "company",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    registerCompanyUser: async function(obj) {
      obj = {   
        _id: obj
      };
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "company/create/sub/user",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    putCompany: async function(obj) {
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "company",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    postCompanyImage: async function(obj) {
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "company/avatar",
          obj,
          Domain.APP_HEADER_FORM_DATA
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    deleteCompany: async function(id) {
      try {
        let response = await this.axios.delete(
          Domain.APP_DOMAIN + "company/" + id,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getCompanieToken: async function(id) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "company/token?_id=",
          id,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getPortal: async function(token, url, port) {
      try {
        
        
        
        let response = await this.axios.get(
          url +
            ":" +
            port +
            "/" +
            "customer/auth/portal/login?token=Bearer" +
            " " +
            token,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  }
};
